import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import { HorizontalListTitle } from "../../../../Constants/Constants";
import { HorizontalColor, HorizontalListData, HorizontalListSubTitle } from "../../../../Data/UiKits/Lists";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalList = () => {
  return (
    <Col xxl="6" xs="12" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={HorizontalListTitle} span={HorizontalListSubTitle} />
        <CardBody>
          <div className="horizontal-list-wrapper dark-list">
            {HorizontalListData &&
              HorizontalListData.map((item, index) => (
                <UL className={`fw-bold list-content ${item.class}`} key={index}>
                  {item.data &&
                    item.data.map((data, i) => (
                      <LI className={`${i === 0 && HorizontalColor[index]}`} key={i}>
                        {data}
                      </LI>
                    ))}
                </UL>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HorizontalList;
